import PropTypes from 'prop-types';

import Box from '@zenbusiness/zui/Box';
import Text from '@zenbusiness/zui/Text';

/**
 * Renders a list of similar businesses
 * @param {object} props - Component props
 * @param {Array<{industry?: string, name: string, url?: string}>} props.items - Array of similar business items
 * @returns {object} The rendered SimilarBusinesses component
 */
function SimilarBusinesses({ items }) {
  if (!items || items.length === 0) {
    return (
      <Box>
        <Text color="secondary" size="sm">
          We searched your area for businesses with similar names.
        </Text>
        <Box
          sx={{
            backgroundColor: '#E8F5E9',
            border: '1px solid #4CAF50',
            borderRadius: 1,
            p: 2,
            mt: 2
          }}
        >
          <Text size="md" weight="medium">
            Good news — we didn&apos;t find any similar business names in your area.
          </Text>
        </Box>
      </Box>
    );
  }

  return (
    <Box>
      <Text color="secondary" mb={2} size="sm">
        We searched your area for businesses with similar names.
      </Text>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
        {items.map((item, index) => (
          <Box
            key={`${item.name}-${index}`}
            sx={{
              backgroundColor: '#EEEEEE',
              border: '1px solid rgba(0, 0, 0, 0.10)',
              borderRadius: 1,
              p: 2,
              width: '100%'
            }}
          >
            {item.industry && (
              <Text color="secondary" size="sm">
                {item.industry}
              </Text>
            )}
            <Text size="md" weight="medium">
              {item.title}
            </Text>
            {item.url && (
              <Text color="secondary" size="sm">
                {item.url}
              </Text>
            )}
          </Box>
        ))}
      </Box>
    </Box>
  );
}

SimilarBusinesses.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      industry: PropTypes.string,
      name: PropTypes.string,
      title: PropTypes.string,
      url: PropTypes.string
    })
  ).isRequired
};

export default SimilarBusinesses;
